import { z } from 'zod'

export const appointmentSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Invalid email address'),
  phone: z.string().regex(/^\+?[\d\s\-()]+$/, 'Invalid phone number'),
  date: z.string().min(1, 'Please select a date'),
  time: z.string().min(1, 'Please select a time'),
  service: z.string().min(1, 'Please select a service'),
  message: z.string().optional(),
})

export const newsletterSchema = z.object({
  email: z.string().email('Invalid email address'),
})

export const contactSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Invalid email address'),
  subject: z.string().min(5, 'Subject must be at least 5 characters'),
  message: z.string().min(10, 'Message must be at least 10 characters'),
})

export const commentSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Invalid email address'),
  content: z.string().min(2, 'Comment must be at least 2 characters'),
})

export type AppointmentFormData = z.infer<typeof appointmentSchema>
export type NewsletterFormData = z.infer<typeof newsletterSchema>
export type ContactFormData = z.infer<typeof contactSchema>
export type CommentFormData = z.infer<typeof commentSchema>
